import { render } from "./welcoming-new-joiners-message.vue?vue&type=template&id=970b8100&lang=pug"
import script from "./welcoming-new-joiners-message.vue?vue&type=script&lang=js"
export * from "./welcoming-new-joiners-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__